import { faDoorClosed, faDoorOpen, faPersonCircleQuestion, faPersonWalkingArrowLoopLeft, faPersonWalkingArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function getPeopleInside(logs, { lockId } = {}) {
  const filtered = lockId
    ? logs.filter(e => e.lockId === lockId || e?.data?.lock?.id === lockId)
    : logs;

  const byActor = new Map();

  for (const e of filtered) {
    const actor = e?.data?.actor;
    if (!actor?.id) continue;
    const rec = byActor.get(actor.id) || { count: 0, actor, e };
    rec.count += 1;
    rec.actor = actor;
    rec.e = e;
    byActor.set(actor.id, rec);
  }

  // prendi solo chi ha conteggio dispari = ancora dentro
  return Array.from(byActor.values())
    .filter(({ count }) => count % 2 === 1)
    .map(({ actor, count, e }) => ({
      actorId: actor.id,
      firstname: actor.firstname ?? null,
      lastname: actor.lastname ?? null,
      email: actor.email ?? null,
      timestamp: e.timestamp ?? null,
      // facoltativo: quante volte è passato (utile per debug)
      eventsCount: count
    }));
}

export function logTypeToString(type){
  switch (type) {
      case "ENTER":
        return "Entrata"
      case "EXIT":
        return "Uscita"
      case "OPEN":
       return "Apertura"
      case "CLOSE":
        return "Chiusura"
      case "UNCLEAR":
        return "Dubbia"
      default:
        return "N.D"
  }
}

export function logTypeClass(type){
  switch (type) {
      case "OPEN":
       return "log-open-row"
      case "CLOSE":
        return "log-close-row"
      default:
        return ""
    }
}

export function logTypeIcon(type){
    switch (type) {
      case "ENTER":
        return <FontAwesomeIcon icon={faPersonWalkingArrowRight} className="text-success"/>
      case "EXIT":
        return <FontAwesomeIcon icon={faPersonWalkingArrowLoopLeft} className="text-danger"/>
      case "OPEN":
       return <FontAwesomeIcon icon={faDoorOpen} />
      case "CLOSE":
        return <FontAwesomeIcon icon={faDoorClosed} />
      case "UNCLEAR":
        return <FontAwesomeIcon icon={faPersonCircleQuestion} className="text-warning"/>
      default:
        return "N.D"
    }
  }